import { required } from "../../../../../../../shared/utils/forms/utils/validationType";

export const useValidationBombolaLegge64896 = (t: any) => {
  return [
    {
      name: "formato",
      validations: [
        {
          name: required,
          params: {
            name: t("bombolaLegge64896.formato")
          }
        }
      ]
    },
    {
      name: "quantita",
      validations: [
        {
          name: required,
          params: {
            name: t("bombolaLegge64896.quantita")
          }
        }
      ]
    }
  ];
};
